import { Alert, Badge, Button, Descriptions, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { generate_query_set, handleApiExceptions, alertify } from "../../../app_methods";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { EaseTable } from "../../../libs/EaseTable";
import { TdsChallan, Settings } from "../../../models";
import { updateCurrentUserAction } from "../../../redux/actions";
import { Text4 } from "../../../styles";
import { ContentCard, PaginationKaBaap } from "../../Common";
import { PermissionHoc } from "../../HOC";
import { getDirectTaxColumns, direct_taxTableFilterNodes } from "./constants";
import { DirectTaxDetail } from "./details";
import { TutorialModal } from "../../../layouts/AppLayout/tutorialModal";
import { STATUSTYPES } from './constants';
import { DirectTaxModal } from './direct_tax_create_modal'


const DirectTax = (props) => {
  const [showDirectTaxModal, setshowDirectTaxModal] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 15,
    current: 1,
    hasNext: true,
    showing: { from: 1, to: 15 },
  });
  const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
  const [showDirectTaxDetailsDrawer, setShowDirectTaxDetailsDrawer] = useState(false);
  const [activedata, setActiveData] = useState({});
  const [filters, setFilters] = useState({});
  const [direct_taxChallans, setDirectTaxChallans] = useState([]);
  const [approvalFlow, setapprovalFlow] = useState(false);
  const [showTutorialModal, setShowTutorialModal] = useState(false);

  const fetchList = async (_pagination = pagination, _filters = filters) => {
    setIsTableLoading(true);
    const response = await TdsChallan.list({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ..._filters });
    if (!response.success) {
      setIsTableLoading(false);
      handleApiExceptions(response);
      return;
    }
    setDirectTaxChallans(generate_query_set(TdsChallan, response.data.results));
    setPagination({ ..._pagination, ...response.data.pagination });
    setIsTableLoading(false);
    if (activedata.id) {
      setActiveData(new TdsChallan(response.data.results.find(x => x.id === activedata.id)))
    }
  };

  const fetchSettings = async () => {
    setIsTableLoading(true);
    const response = await Settings.list()
    if (!response.success) {
      handleApiExceptions(response);
      return;
    }
    setapprovalFlow(response.data.tax_payments_settings.enable_tax_approver_flow);
    setIsTableLoading(false);
  }

  useEffect(() => {
    props.onChildMount();
    if ((props.current_user || {}).key) {
      fetchSettings();
      fetchList({ ...pagination }, { ...filters });
    }
  }, []);


  const toggleDirectTaxChallanModal = (obj = {}) => {
    setActiveData(obj);
    setshowDirectTaxModal(!showDirectTaxModal);
  };

  const toggleDirectTaxDetailsDrawer = (obj = {}) => {
    setActiveData(obj);
    setShowDirectTaxDetailsDrawer(!showDirectTaxDetailsDrawer);
  };

  const toggleStatusInfoDrawer = () => {
    setShowStatusInfoDrawer(!showStatusInfoDrawer);
  };

  const ButtonOne = PermissionHoc(Button, "DIRECT_TAX_CHALLAN_WRITE", {
    is_component: true,
    fallbackComponent: null,
  });

  const toggleTutorialModal = () => {
    setShowTutorialModal(!showTutorialModal);
  };

  const tableColumns = getDirectTaxColumns({
    toggleDirectTaxDetailsDrawer,
    toggleStatusInfoDrawer,
    toggleDirectTaxChallanModal
  });

  let filterNodes = direct_taxTableFilterNodes();

  const handleTableChange = (tableInfo) => {
    if (tableInfo.trigger == "columns") return;
    let _pagination = tableInfo.pagination;
    if (tableInfo.trigger == "filters") _pagination.current = 1;
    setPagination(_pagination);
    setFilters(tableInfo.filters);
    fetchList(_pagination, tableInfo.filters);
  };

  const onPageChange = (_pagination) => {
    debugger
    setPagination({ ..._pagination });
    fetchList({ ..._pagination }, filters);
  };

  return (
    props.current_user.tdtp ?
      <div>
        <ContentCard className="p-3">

          <div className="w-100 p-3 d-flex justify-content-end">
            {(props.current_user.user.role || props.current_user.user.is_admin) ?
              <ButtonOne
                type="primary"
                style={{ marginLeft: "10px" }}
                ghost
                onClick={() => toggleDirectTaxChallanModal(true)}
              >
                Create Challan
              </ButtonOne>
              : null}
          </div>
          <div>
            <EaseTable
              rowKey="id"
              loading={isTableLoading}
              data={direct_taxChallans}
              columns={tableColumns}
              fixedSelectable={!isMobile}
              handleTableChange={handleTableChange}
              pagination={pagination}
              totalRecords={pagination.total}
              filterNodes={filterNodes}
            />
            <PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
          </div>
        </ContentCard>

        <DirectTaxDetail
          visible={showDirectTaxDetailsDrawer}
          onClose={() => toggleDirectTaxDetailsDrawer()}
          direct_tax={activedata}
          fetchChallanList={fetchList}
          user={props.current_user}
          approvalFlow={approvalFlow}
        />
        <EaseDrawer
          visible={showStatusInfoDrawer}
          onClose={toggleStatusInfoDrawer}
          hideFooter
          title="DirectTax Challan statuses"
          width={500}
        >
          <Descriptions
            bordered
            className="mt-3"
            size="small"
            layout="horizontal"
            column={1}
          >
            {Object.keys(STATUSTYPES).map((key, index) => {
              return (
                <Descriptions.Item
                  label={
                    <Badge
                      color={STATUSTYPES[key].color}
                      text={<Text4>{STATUSTYPES[key].label}</Text4>}
                    />
                  }
                >
                  {STATUSTYPES[key].description}
                </Descriptions.Item>
              );
            })}
          </Descriptions>
        </EaseDrawer>

        <TutorialModal
          visible={showTutorialModal}
          title="Direct Tax Portal Guide"
          url={"https://www.youtube.com/embed/iNPlAgbxI84"}
          toggleTutorialModal={toggleTutorialModal}
        />

        <DirectTaxModal
          visible={showDirectTaxModal}
          toggleDirectTaxChallanModal={toggleDirectTaxChallanModal}
          direct_tax={activedata}
          fetchChallanList={fetchList}
          user={props.current_user}
        // loading={isPaying}
        />
      </div>
      :
      <Alert
        message="Error"
        description="You are not authorised to view this page."
        type="error"
        showIcon
      />
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(DirectTax, "DIRECT_TAX_CHALLAN_READ"));
